import MapService from '@/services/map-service'
import { MAP_SETTINGS } from '@/configs/constants'

const state = {
  map: null,
  hubsLayer: null,
  previousStepsPathLayer: null,
  futureStepsPathLayer: null,
  isMouseHoverHub: false,
  hoveredStep: null
}

const getters = {
}

const actions = {
  initiateMap ({ commit }) {
    const map = MapService.buildMap()
    commit('setMap', { map })
    commit('addMapDragEventListeners')
    return Promise.resolve()
  },
  displayHubs ({ state, commit, dispatch }, { packagePayload, hubClickCallback }) {
    let hubsLayer = MapService.buildHubsLayer(packagePayload, state)
    let previousStepsPathLayer = MapService.buildPreviousStepsPath(packagePayload)
    let futureStepsPathLayer = MapService.buildFutureStepsPath(packagePayload)
    commit('addPathLayer', { previousStepsPathLayer, futureStepsPathLayer })
    commit('addHubsLayer', { layer: hubsLayer })
    commit('addMarkerAnimationLayer', { packagePayload })
    commit('registerHubClickEvent', { callback: hubClickCallback })
    return dispatch('registerMouseHoverEvent')
  },
  registerMouseHoverEvent ({ state, commit, dispatch }) {
    const callback = MapService.createMouseHoverCalllback(state, dispatch)
    commit('registerMouseHoverEvent', { callback })
    return Promise.resolve()
  },
  removeHubs ({ commit }) {
    commit('removeHubsLayer')
    commit('removePathLayer')
    commit('removeMarkerAnimationLayer')
    return Promise.resolve()
  },
  zoomAndCenterHubs ({ commit }, { packagePayload }) {
    const extent = MapService.getHubsExtent(packagePayload)
    commit('zoomAndCenterHubs', { extent })
    return Promise.resolve()
  },
  centerMapOnHub ({ commit }, { step }) {
    commit('centerMapOnHub', { step })
    return Promise.resolve()
  },
  bounceHub ({ commit }, { step }) {
    commit('bounceHub', { step })
    return Promise.resolve()
  },
  centerMapOnDefaultPosition ({ commit }) {
    commit('centerMapOnDefaultPosition')
    return Promise.resolve()
  },
  startHoveringHub ({ commit }, { step }) {
    commit('addHoveredStepAndActivateStyles', { step })
    return Promise.resolve()
  },
  stopHoveringHub ({ commit }) {
    commit('removeHoveredStepAndDeactiveStyles')
    return Promise.resolve()
  }
}

const mutations = {
  setMap (state, { map }) {
    state.map = map
  },
  addMapDragEventListeners (state) {
    state.map.on('pointerdrag', function (evt) {
      state.map.getViewport().classList.add('cursor-dragging')
    })
    state.map.on('pointerup', function (evt) {
      state.map.getViewport().classList.remove('cursor-dragging')
    })
  },
  addHubsLayer (state, { layer }) {
    state.hubsLayer = layer
    state.map.addLayer(layer)
  },
  removeHubsLayer (state) {
    state.map.removeLayer(state.hubsLayer)
    state.hubsLayer = null
  },
  addPathLayer (state, { previousStepsPathLayer, futureStepsPathLayer }) {
    state.previousStepsPathLayer = previousStepsPathLayer
    state.futureStepsPathLayer = futureStepsPathLayer
    state.map.addLayer(previousStepsPathLayer)
    state.map.addLayer(futureStepsPathLayer)
  },
  removePathLayer (state) {
    state.map.removeLayer(state.previousStepsPathLayer)
    state.map.removeLayer(state.futureStepsPathLayer)
    state.previousStepsPathLayer = null
    state.futureStepsPathLayer = null
  },
  registerHubClickEvent (state, { callback }) {
    state.map.on('click', function (evt) {
      const feature = state.map.forEachFeatureAtPixel(evt.pixel, feature => feature)

      if (feature && feature.values_ && feature.values_.step) {
        const step = feature.values_.step
        callback(step)

        const coordinates = [step.info.address.longitude, step.info.address.latitude]
        MapService.setMapCenter(state.map, coordinates)
      }
    })
  },
  centerMapOnHub (state, { step }) {
    const coordinates = [step.info.address.longitude, step.info.address.latitude]
    MapService.setMapCenter(state.map, coordinates)
  },
  bounceHub (state, { step }) {
    const feature = MapService.getHubFeature(state.hubsLayer, step)
    MapService.onHubClick(feature, state.hubsLayer)
  },
  centerMapOnDefaultPosition (state) {
    const coordinates = [MAP_SETTINGS.defaultCenter.longitude, MAP_SETTINGS.defaultCenter.latitude]
    const zoom = MAP_SETTINGS.defaultZoom
    MapService.setMapCenterAndZoom(state.map, coordinates, zoom)
  },
  registerMouseHoverEvent (state, { callback }) {
    MapService.createHubPopup(state.map)
    MapService.registerPointerMoveEvents(state.map, callback)
  },
  zoomAndCenterHubs (state, { extent }) {
    MapService.zoomAndCenterMapOnExtent(state.map, extent)
  },
  addMarkerAnimationLayer (state, { packagePayload }) {
    MapService.addArrowMarker(state.map, packagePayload)
  },
  removeMarkerAnimationLayer (state) {
    MapService.removeArrowMarker(state.map)
  },
  addHoveredStepAndActivateStyles (state, { step }) {
    state.isMouseHoverHub = true
    state.hoveredStep = step
    MapService.stepCursorPointer(state.map)
    MapService.addHubPopup(state.map, step)
  },
  removeHoveredStepAndDeactiveStyles (state) {
    state.isMouseHoverHub = false
    state.hoveredStep = null
    MapService.cleanCursorStyle(state.map)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
